import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Capacitor } from '@capacitor/core';
import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics';

declare let gtag: Function;

@Injectable({ providedIn: 'root' })
export class AnalyticsService {

  constructor(private router: Router) {}

  initAutoTracking() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const page = event.urlAfterRedirects;

        if (Capacitor.getPlatform() === 'web') {
          gtag('event', 'page_view', {
            page_path: page,
            page_location: window.location.href
          });
        } else {
          FirebaseAnalytics.logEvent({
            name: 'screen_view',
            params: {
              firebase_screen: page,
              firebase_screen_class: page
            }
          });
        }
      });
  }
}
